/**
 * pixi-particles — zones/EdgeZone.ts
 * Ported from Phaser.GameObjects.Particles.Zones.EdgeZone
 *
 * Places particles at consecutive points along a shape's edge (via the
 * source's `getPoints(quantity, stepRate)` method), advancing through the
 * point list `quantity`-worth of particles at a time (optionally yoyo-ing
 * back and forth, or reusing the first point as the seam once the loop
 * has come full circle).
 */
import { IPoint, IZoneSource } from './Shapes';
import { AnyParticle } from '../EmitterOp';

export class EdgeZone
{
    type = 'edge';
    counter = -1;
    points: IPoint[] = [];

    constructor (
        public source: IZoneSource,
        public quantity: number,
        public stepRate?: number,
        public yoyo = false,
        public seamless = true,
        public total = -1
    )
    {
        this.updateSource();
    }

    getPoint (particle: AnyParticle): void
    {
        this.counter++;

        if (this.counter >= this.points.length)
        {
            this.counter = 0;
        }

        var point = this.points[this.counter];

        if (point)
        {
            particle.x = point.x;
            particle.y = point.y;
        }
    }

    updateSource (): this
    {
        var points = this.source.getPoints!(this.quantity, this.stepRate);

        if (this.seamless && points.length > 1)
        {
            var last = points[points.length - 1];
            var first = points[0];

            if (last.x === first.x && last.y === first.y)
            {
                points.pop();
            }
        }

        if (this.yoyo)
        {
            var reversed = points.slice(0, -1).reverse();

            points = points.concat(reversed);
        }

        this.points = points;

        return this;
    }

    changeSource (source: IZoneSource): this
    {
        this.source = source;

        return this.updateSource();
    }
}

export default EdgeZone;
